module.exports = __webpack_public_path__ + "static/media/blank_profile.c9b0766b.jpg";